
// hover-menu.directive.ts
import { Directive, Input, HostListener, OnDestroy } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';

@Directive({
  selector: '[hoverMenu]',
  standalone: true,
  exportAs: 'hoverMenu',
})
export class HoverMenuDirective implements OnDestroy {
  @Input() hoverDelay: number = 50;
  
  private timedOutCloser: NodeJS.Timeout | null = null;

  constructor(private menuTrigger: MatMenuTrigger) {}

  @HostListener('mouseenter')
  onMouseEnter(): void {
    this.clearTimeout();
    this.menuTrigger.openMenu();
  }

  @HostListener('mouseleave')
  onMouseLeave(): void {
    this.timedOutCloser = setTimeout(() => {
      this.menuTrigger.closeMenu();
    }, this.hoverDelay);
  }

  // Método público para ser usado desde el template del menu
  onMenuMouseEnter(): void {
    this.clearTimeout();
  }

  onMenuMouseLeave(): void {
    this.timedOutCloser = setTimeout(() => {
      this.menuTrigger.closeMenu();
    }, this.hoverDelay);
  }

  private clearTimeout(): void {
    if (this.timedOutCloser) {
      clearTimeout(this.timedOutCloser);
      this.timedOutCloser = null;
    }
  }

  ngOnDestroy(): void {
    this.clearTimeout();
  }
}